import Head from 'next/head';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Constants } from '../../util/Constants';

export default function TemplateBanner({ children, metaTags }) {
  const { asPath } = useRouter();
  const host = useSelector((state) => state.host.host);
  const timestamp = new Date().getTime();
  const url = `https://www.${host}${asPath}?t=${timestamp}?latest`;
  const ogImage = metaTags?.length > 0 ? metaTags[0]?.og_image : undefined;
  const img =
    Constants.cloudinaryImage + children?.field_web_small_image?.webimage;

  const getSocialImage = (ogImage, webSmallImage, banner) => {
    if (!ogImage && !webSmallImage && !banner) {
      return Constants.cloudinaryImage + '/images/placeholder.png';
    }

    if (ogImage) {
      return ogImage;
    } else if (!ogImage && webSmallImage) {
      return img;
    } else {
      return Constants.cloudinaryImage + banner;
    }
  };

  return (
    <div>
      <Head>
        <meta content="text/html; charset=UTF-8" name="Content-Type" />
        <meta
          key={`unique-image-${children.id}-t=${timestamp}`}
          name="image"
          property="og:image"
          content={getSocialImage(
            ogImage,
            children?.field_web_small_image?.webimage,
            children?.field_template_banner_bynder?.webimage
          )}
        />
        <meta
          property="og:url"
          content={url}
          key={`og-url-${children.id}-t=${timestamp}`}
        ></meta>
        <meta
          property="og:type"
          content="website"
          key={`og-type-${children.id}`}
        ></meta>
        {/* <meta name="description" content={`<meta name=&quot;twitter:card&quot; content=&quot;summary_large_image&quot;>  <meta name=&quot;twitter:site&quot; content=&quot;@pakisans&quot;>  <meta name=&quot;twitter:title&quot; content=&quot;test&quot;>  <meta name=&quot;twitter:image&quot; content=&quot;${encodeURI(getSocialImage(ogImage, children?.field_web_small_image?.webimage, children?.field_template_banner_bynder?.webimage))}?4362984378;`}></meta> */}
        <meta
          property="twitter:card"
          name="twitter:card"
          content="summary_large_image"
        />
        <meta
          key={`unique-twitter-image-${children.id}-t=${timestamp}?latest`}
          property="twitter:image"
          name="twitter:image"
          content={getSocialImage(
            ogImage,
            children?.field_web_small_image?.webimage,
            children?.field_template_banner_bynder.webimage
          )}
        ></meta>
        <meta
          property="twitter:image:alt"
          name="twitter:image:alt"
          content="shared-image"
        ></meta>
        <meta httpEquiv="Cache-Control" content="no-store, must-revalidate" />
        <meta httpEquiv="Pragma" content="no-cache" />
        <meta httpEquiv="Expires" content="0" />
      </Head>
      <div className="template-banner">
        <Image
          alt={'banner'}
          layout="fill"
          src={
            children?.field_template_banner_bynder &&
            children?.field_template_banner_bynder?.webimage
              ? children?.field_template_banner_bynder?.webimage
              : '/images/placeholder.png'
          }
        />
      </div>
    </div>
  );
}
